// BALLPARK PRICING — placeholder rates, edit freely to match real pricing.
// base = per-visit dispatch fee, perPerson = additional per person tested.
export const PRICING = {
  services: {
    "Drug Testing": { base: 60, perPerson: 45 },
    "Pre-Employment & Pre-Screening": { base: 60, perPerson: 50 },
    "Workers' Compensation Testing": { base: 95, perPerson: 55 },
    "DNA & Paternity Testing": { base: 120, perPerson: 110 },
    "DOT Testing": { base: 75, perPerson: 60 },
    "Random Employee Testing": { base: 80, perPerson: 40 },
    "Post-Accident Testing": { base: 150, perPerson: 65 },
    "Reasonable Suspicion Testing": { base: 150, perPerson: 65 },
  },
};

// Cities with no travel fee (core Cedar Rapids–Iowa City corridor)
export const CORE_CITIES = [
  "Cedar Rapids",
  "Iowa City",
  "Marion",
  "Hiawatha",
  "Coralville",
  "North Liberty",
];

export const OUTER_TRAVEL_FEE = 45;

export const DEPOSIT_AMOUNT = 50;
